module.exports = __webpack_public_path__ + "static/img/image_17.073dcf4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/activty/questionnaire/image_17.png
// module id = AUan
// module chunks = 1